export default "__VITE_ASSET__f3cd9e75__"